var styles = {"error-message":"styles_error-message__13F3L py1 px2","errorMessage":"styles_error-message__13F3L py1 px2"};

export default styles;
//# sourceMappingURL=styles.css.js.map
